/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * Zäkra API 1.0
 * REST API for Zäkra
 * OpenAPI spec version: v1
 */

export type RouteFillerUnavailableReasonEnum =
  (typeof RouteFillerUnavailableReasonEnum)[keyof typeof RouteFillerUnavailableReasonEnum];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RouteFillerUnavailableReasonEnum = {
  NotSearched: 0,
  NoneInCorridor: 1,
  AllTaken: 2,
  NoneFitsTime: 3,
} as const;
